import { Type, type Static } from '@sinclair/typebox';
import { StringEnum } from '../../utils/typebox';
import { InsertOrganizationSchema } from './organization.schema';

const OrganizationNameSchema = Type.String({ minLength: 1, maxLength: 255, pattern: '\\S' });

export const CreateOrganizationBodySchema = Type.Object(
  {
    name: OrganizationNameSchema,
  },
  { additionalProperties: false },
);

export const UpdateOrganizationBodySchema = Type.Object(
  {
    name: Type.Optional(OrganizationNameSchema),
    force_mfa: Type.Optional(InsertOrganizationSchema.properties.force_mfa),
    account_limit: Type.Optional(Type.Union([Type.Integer({ minimum: 1 }), Type.Null()])),
  },
  { additionalProperties: false },
);

export const InviteMemberBodySchema = Type.Object({
  email: Type.String({ format: 'email', minLength: 1, maxLength: 50 }),
  role: StringEnum(['admin', 'member', 'owner']),
});

export const ResendInviteMemberBodySchema = Type.Object({
  email: Type.String(),
});

export const UpdateMemberBodySchema = Type.Object({
  role: StringEnum(['admin', 'member', 'owner']),
});

export type CreateOrganizationBody = Static<typeof CreateOrganizationBodySchema>;
export type UpdateOrganizationBody = Static<typeof UpdateOrganizationBodySchema>;
export type InviteMemberBody = Static<typeof InviteMemberBodySchema>;
export type ResendInviteMemberBody = Static<typeof ResendInviteMemberBodySchema>;
export type UpdateMemberBody = Static<typeof UpdateMemberBodySchema>;
